import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import "./_style.scss";

const TimelineEvent = ({
  date,
  primaryText,
  secondaryText,
  type,
  ...other
}) => (
  <div
    className={
        classNames({
          "timeline-event": true,
          [`--${type}`]: type,
        })
      }
    {...other}
  >
    <div className="timeline-event__inner">
      <span className="timeline-event__date">{date}</span>
      <span className="timeline-event__primary-text">
        {primaryText}
&nbsp;
      </span>
      <span className="timeline-event__secondary-text">{secondaryText}</span>
    </div>
  </div>
);

TimelineEvent.propTypes = {
  date: PropTypes.string.isRequired,
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["staff", "donor", "milestone"]).isRequired,
};

export default TimelineEvent;
